import {Avatar, DatePicker, Input, Switch, TimePicker} from 'antd'
import {getId} from 'apis/model/base'
import classNames from 'classnames'
import FieldsFactory from 'components/form/FieldsFactory'
import FormActionBar from 'components/form/FormActionBar'
import {createSelectValue, createValue} from 'components/form/utils'
import {Formik, FormikConsumer} from 'formik'
import {formatDate, getDateString, parseDayjs} from 'helpers/datetimeHelpers'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import withTranslate from 'modules/local/withTranslate'
import React, {useContext, useMemo, useState} from 'react'
import {compose, mapProps, pure} from 'recompose'
import {SelectWidget} from 'views/AppLocals/custom/ReactSelectComponents'
import {NullAsDefault, shallowDiff} from 'views/Shared'
import {getType} from '../../../../apis/model/base'
import LookupField from '../../../../components/LookupField'
import {renderIf, renderIfElse, renderSelf} from '../../../Shared'
import {renderCourseClassTeacherAssignment} from '../../../Workspace/Course/functions/renderCourseClassTimetable'
import {appClassNames} from '../../custom/appClassNames'
import EntityList from '../../EntityList'
import {createControlledFormField} from '../../factory/createFormField'
import {bindQueryParam, bindQueryParams} from '../../functions/routerHelper'
import {HeaderWithIconLine} from '../../Templates/items/ListHeader'
import {SubjectSelector} from '../components/SubjectSelector'
import {TeacherSelector} from '../components/TeacherSelector'
import useCourseClassTimetable from './useCourseClassTimetable'
import {IoCalendarOutline} from "react-icons/io5";
import Pure from "../../../../components/Pure";
import dayjs from "dayjs";
import {course_class_getCourseClassMilestones_Api, course_getCourseClassSubjects_Api} from "../../../../apis";
import {IoIosTimer} from "react-icons/io";
import TooltipApp from "../../../../components/TooltipApp";
import {BsCaretDownFill, BsCaretRightFill, BsInboxesFill} from "react-icons/bs";
import useToggle from "react-use/lib/useToggle";
import {PiListNumbersBold, PiMapPinLineFill, PiPlusBold, PiWarningCircleFill} from "react-icons/pi";
import {BiSolidEdit, BiTrash} from "react-icons/bi";
import {createInputModal, showDeleteConfirmDialog} from "../../factory/createConfirmDialog";
import {ItemInformation} from "../../Organization/OrganizationEntity";
import getTitle from "../../../../helpers/getTitle";
import {FaUserTie} from "react-icons/fa6";
import {GoDotFill} from "react-icons/go";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {DoubleValueItem} from "../../CatholicHousehold/components/CatholicHouseholdComponents";
import {ActionModalWrapper} from "../../../../components/form/ActionModalWrapper";

const dayOfWeeks = [
    {value: 'S', label: 'sun'},
    {value: 'M', label: 'mon'},
    {value: 'T', label: 'tue'},
    {value: 'W', label: 'wed'},
    {value: 'T', label: 'thu'},
    {value: 'F', label: 'fri'},
    {value: 'S', label: 'sat'},
]

const DaysOfWeek = ({name, value, defaultValue = "0000000", handleChange = NullAsDefault}) => {
    const t = useTranslate();
    const {isSm} = useContext(LayoutContext);
    const weekdaysArray = Object.assign([], value || defaultValue)
    const [current, setCurrent] = useState(false)

    return (
        <div className={isSm ? 'flex flex-wrap flex-1 gap-2' : 'grid grid-cols-8 gap-3'}>
            {dayOfWeeks.map(({label}, index) => {
                const isActive = [0, 1, 2, 3, 4, 5, 6].includes(index)
                return (
                    <button
                        key={index}
                        disabled={!!!isActive}
                        onClick={() => {
                            if (isActive) {
                                weekdaysArray[index] = weekdaysArray[index] === '0' ? '1' : '0';
                                handleChange(weekdaysArray.join(''))
                            }
                        }}
                        style={{padding: '5px 12px'}}
                        className={classNames(
                            'flex flex-center rounded-md font-bold text-xs uppercase cursor-pointer',
                            !!Number(weekdaysArray[index])
                                ? 'bg-primary-100 text-primary-900' : 'background-200 text-color-100',
                            isActive ? "font-bold hover:bg-primary-50 hover:text-primary-500 cursor-pointer"
                                : "italic border-0 opacity-50 pointer-events-none"
                        )}>
                        {t(label)}
                    </button>
                )
            })}
            <button
                onClick={() => {
                    if (current === false) {
                        handleChange('1111111')
                        setCurrent(true)
                    } else {
                        handleChange('0000000')
                        setCurrent(false)
                    }
                }}
                style={{padding: '4px 10px', borderRadius: '0.375rem', whiteSpace: 'nowrap', cursor: 'pointer'}}
                className="flex flex-center border border-dashed border-primary-500 hover:bg-primary font-medium text-xs text-primary hover:text-white italic">
                {t('everyday')}
            </button>
        </div>
    );
}

const TimetableDetails = ({name, value, defaultValue = [], handleChange = NullAsDefault}) => {
    const t = useTranslate()
    const timetable_details = value || defaultValue;
    const [newValue, setNewValue] = useState({
        start_time: dayjs().set('hour', 8).set('minute', 0),
        end_time: dayjs().set('hour', 8).set('minute', 0),
        location_address: null,
        id: Date.now()
    })
    return (
        <div className="flex flex-col gap-3">
            <div className="flex items-center gap-3">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3 flex-1">
                    <div className="col-span-1 flex gap-3">
                        <DatePicker
                            allowClear={true}
                            showTime={true}
                            showSecond={false}
                            placeholder={t('Select date')}
                            format="DD/MM/YYYY - HH:mm"
                            suffixIcon={<IoCalendarOutline className="text-color-500"/>}
                            defaultValue={dayjs().set('hour', 8).set('minute', 0)}
                            onChange={(dateObj, dateString) => {
                                if (dateObj) {
                                    setNewValue({...newValue, start_time: dateObj.utc().format('YYYY-MM-DDTHH:mm:ssZ')})
                                } else {
                                    setNewValue({...newValue, start_time: null})
                                }
                            }}
                            style={{
                                fontSize: 12,
                            }}
                        />
                        <DatePicker
                            allowClear={true}
                            showTime={true}
                            showSecond={false}
                            placeholder={t('Select date')}
                            format="DD/MM/YYYY - HH:mm"
                            suffixIcon={<IoCalendarOutline className="text-color-500"/>}
                            defaultValue={dayjs().set('hour', 8).set('minute', 0)}
                            onChange={(dateObj, dateString) => {
                                if (dateObj) {
                                    setNewValue({...newValue, end_time: dateObj.utc().format('YYYY-MM-DDTHH:mm:ssZ')})
                                } else {
                                    setNewValue({...newValue, end_time: null})
                                }
                            }}
                            style={{
                                fontSize: 12,
                            }}
                        />
                    </div>
                    <div className="col-span-1 flex gap-3">
                        <Input
                            className="flex-1"
                            placeholder={t('enter note')}
                            onChange={(e, ...rest) => {
                                setNewValue({...newValue, notes: e.target.value})
                            }}
                        />
                        <Avatar
                            size={32}
                            icon={<PiPlusBold size={15} className="text-primary"/>}
                            className="flex flex-center bg-primary-50 hover:bg-primary-100 rounded-md cursor-pointer"
                            onClick={() => {
                                let _timetable_details = _.cloneDeep(timetable_details);
                                _timetable_details.push(newValue);
                                handleChange(_timetable_details)
                                setNewValue({
                                    start_time: dayjs().set('hour', 8).set('minute', 0),
                                    end_time: dayjs().set('hour', 8).set('minute', 0),
                                    location_address: null
                                })
                            }}
                        />
                    </div>
                </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {timetable_details.map((timetable_detail, idx) => {
                    const {start_time, end_time, location_address, notes, is_holiday} = timetable_detail ?? {}
                    const isHappened = dayjs(start_time).isBefore(dayjs())

                    return (
                        <div key={idx} style={{padding: '6px 0'}}
                             className={classNames(
                                 "flex flex-col custom-item-render custom-render-border relative",
                                 isHappened && 'opacity-35'
                             )}>
                            <div style={{fontSize: 12}}
                                 className="font-bold text-color-000 capitalize tracking-wide leading-snug mr-6">
                                <span className="font-medium text-color-100 italic">
                                    {`${idx + 1}. ${parseDayjs(start_time)?.format("dddd")}, `}
                                </span>
                                {formatDate(start_time, "DD/MM/YYYY")}
                            </div>
                            {renderIf(
                                is_holiday === 0,
                                <DoubleValueItem
                                    showIcon={true}
                                    labelFirst="time"
                                    valueFirst={`${formatDate(start_time, 'HH:mm')} -> ${formatDate(end_time, 'HH:mm')}`}
                                    labelSecond={location_address ? 'in' : ''}
                                    valueSecond={
                                        <span className="font-semibold text-blue-500">
                                        {location_address}
                                    </span>
                                    }
                                    style={{fontSize: 11}}
                                    className="italic"
                                />
                            )}
                            {renderIf(
                                notes,
                                <ItemInformation
                                    showIcon={true}
                                    label="notes"
                                    value={
                                        <span className="font-semibold text-color-100 whitespace-pre-line">
                                            {notes}
                                        </span>
                                    }
                                    style={{fontSize: 11}}
                                    className="flex italic"
                                />
                            )}
                            <div className="absolute top-5 right-5 flex gap-2">
                                <BiSolidEdit
                                    size={13}
                                    className="text-blue-500 hover:text-blue-700 cursor-pointer contextIcon"
                                    onClick={() => {
                                        let _timetable_details = _.cloneDeep(timetable_details);
                                        const itemIndex = _timetable_details.findIndex(item => item.id === timetable_detail?.id);
                                        if (itemIndex !== -1) {
                                            createInputModal({
                                                title: 'add note',
                                                message: 'notes',
                                                placeholder: 'input your note',
                                                translate: t,
                                                value: _timetable_details[itemIndex]["notes"],
                                                onOk: (inputValue) => {
                                                    _timetable_details[itemIndex]["notes"] = inputValue;
                                                    handleChange(_timetable_details)
                                                },
                                            });
                                        }
                                    }}
                                />
                                <BiTrash
                                    size={13}
                                    className="text-primary-200 hover:text-primary-700 cursor-pointer contextIcon"
                                    onClick={() => {
                                        let _timetable_details = _.cloneDeep(timetable_details);
                                        showDeleteConfirmDialog({
                                            translate: t,
                                            title: 'delete lesson',
                                            message: 'are you sure you want to delete lesson',
                                            onOk: () => {
                                                _.remove(_timetable_details, {id: timetable_detail?.id});
                                                handleChange(_timetable_details)
                                            },
                                        });
                                    }}
                                />
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

const formSchema = {
    phase: {
        inline: true,
        className: appClassNames.inline_2,
        description: 'description phase',
        children: [
            {
                label: 'phase',
                name: 'phase_nbr',
                component: compose(
                    withTranslate,
                    mapProps(({name, translate, onChange, value}) => ({
                        name,
                        allowClear: true,
                        className: 'w-full',
                        value: value || undefined,
                        onChange: (value) => {
                            onChange(createSelectValue('phase_nbr', value))
                        },
                        placeholder: translate('---Choose One---'),
                        options: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((e) => ({
                            value: e,
                            label: `${translate('phase')} ${e}`,
                        })),
                    })),
                    pure
                )(SelectWidget),
            },
            {
                label: 'phase title',
                name: 'phase_title',
                component: createControlledFormField({
                    placeholder: 'phase title',
                }),
            },
        ],
    },
    from_to_date: {
        inline: true,
        className: "grid grid-cols-2 gap-3",
        children: [
            {
                label: 'from date',
                name: 'from_date',
                component: ({name, value, onChange}) => {
                    return (
                        <Translate>
                            {(t) => (
                                <DatePicker
                                    allowClear={true}
                                    showTime={false}
                                    className="w-full"
                                    placeholder={t('Select date')}
                                    format="DD/MM/YYYY"
                                    suffixIcon={<IoCalendarOutline className="text-color-500"/>}
                                    defaultValue={value ?? undefined}
                                    onChange={(value) => {
                                        onChange(createValue(name, value))
                                    }}
                                />
                            )}
                        </Translate>
                    )
                },
            },
            {
                label: 'to date',
                name: 'to_date',
                component: ({name, value, onChange}) => {
                    return (
                        <Translate>
                            {(t) => (
                                <DatePicker
                                    showTime={false}
                                    showSecond={false}
                                    className="w-full"
                                    placeholder={t('Select date')}
                                    allowClear={true}
                                    format="DD/MM/YYYY"
                                    suffixIcon={<IoCalendarOutline className="text-color-500"/>}
                                    defaultValue={value ?? undefined}
                                    onChange={(value) => {
                                        onChange(createValue(name, value))
                                    }}
                                />
                            )}
                        </Translate>
                    )
                },
            },
        ],
    },
    days_of_week: {
        title: 'day of week',
        children: [
            {
                name: 'days_of_week',
                component: createControlledFormField({
                    className: 'w-full',
                    Component: DaysOfWeek,
                    withProps: ({name, value, onChange}) => {
                        return ({
                            defaultValue: value,
                            name: "days_of_week",
                            handleChange: (_value) => {
                                onChange(createValue(name, _value))
                            }
                        })
                    },
                    withValues: ({resetKey}) => ({
                        resetKey,
                    }),
                }),
            },
        ],
    },
    from_to_time: {
        inline: true,
        className: 'grid grid-cols-2 gap-3',
        children: [
            {
                label: 'start time',
                name: 'from_time',
                component: ({name, value, onChange}) => {
                    return (
                        <TimePicker
                            className="w-full"
                            allowClear={true}
                            placeholder="07:00"
                            format="HH:mm"
                            suffixIcon={<IoIosTimer className="text-color-500"/>}
                            defaultValue={value ? dayjs(value, 'HH:mm') : undefined}
                            onChange={(value) => {
                                onChange(createValue(name, value))
                            }}
                        />
                    )
                },
            },
            {
                label: 'end time',
                name: 'to_time',
                component: ({name, value, onChange}) => {
                    return (
                        <Translate>
                            {(t) => (
                                <TimePicker
                                    className="w-full"
                                    placeholder="12:00"
                                    allowClear={false}
                                    format="HH:mm"
                                    suffixIcon={<IoIosTimer className="text-color-500"/>}
                                    defaultValue={value ? dayjs(value, 'HH:mm') : undefined}
                                    onChange={(value) => {
                                        onChange(createValue(name, value))
                                    }}
                                />
                            )}
                        </Translate>
                    )
                },
            },
        ],
    },
    location_address: {
        title: 'locations',
        children: [
            {
                name: 'location_address',
                component: ({name, value, onChange, form, ...restForm}) => {
                    const values = _.get(form, 'values', {})
                    const owner = _.get(values, 'course_class.owner', {})
                    const owner_type = getType(owner) || values?.owner_type;
                    const owner_id = owner?.id || values?.owner_id;
                    return (
                        <Translate>
                            {(t) => (
                                <LookupField
                                    createIfNotExists={true}
                                    defaultValue={values?.location_address}
                                    apiPath={`/lookup/${owner_type}/${owner_id}/field/location_address/gets`}
                                    name={name}
                                    placeholder={t('choose or create address')}
                                    handleChange={(e) => {
                                        onChange(createValue('location_address', e.target.value))
                                    }}
                                />
                            )}
                        </Translate>
                    )
                },
            },
        ],
    },
    teacher: {
        title: 'teacher',
        children: [
            {
                name: 'teacher',
                component: mapProps(({name, value, form, onChange}) => {
                    const {owner_id, owner_type} = form?.values ?? {}
                    return {
                        name,
                        value,
                        onChange,
                        owner_id,
                        owner_type,
                    }
                })(TeacherSelector),
            },
        ],
    },
    subject: {
        title: 'subjects',
        children: [
            {
                name: 'subject',
                component: mapProps(({name, value, form, onChange}) => ({
                    name,
                    value,
                    onChange,
                    course_id: form?.values?.course_id,
                    customConfigs: {
                        apiInfo: course_getCourseClassSubjects_Api,
                        query: bindQueryParam({id: form?.values?.course_class_id}),
                    }
                }))(SubjectSelector),
            },
        ],
    },
    timetable_details: {
        // title: 'timetable details',
        children: [
            {
                name: 'timetable_details',
                component: createControlledFormField({
                    className: 'w-full',
                    Component: TimetableDetails,
                    withProps: ({name, value, onChange}) => ({
                        defaultValue: value,
                        handleChange: (_value) => {
                            onChange(createValue(name, _value))
                        }
                    }),
                    withValues: ({resetKey}) => ({
                        resetKey,
                    }),
                }),
            },
        ],
    },
    notes: {
        title: 'notes',
        children: [
            {
                name: 'notes',
                component: createControlledFormField({
                    rows: 3,
                    className: 'w-full',
                    placeholder: 'notes',
                    Component: Input.TextArea,
                }),
            },
        ],
    },
    is_holiday: {
        title: 'holiday',
        children: [
            {
                name: 'is_holiday',
                component: ({name, value, onChange}) => (
                    <Translate>
                        {(t) => (
                            <Switch
                                checked={value}
                                checkedChildren={<span className="font-medium italic">{t('yes')}</span>}
                                onChange={(checked) => {
                                    onChange(createValue(name, Number(checked)))
                                }}
                            />
                        )}
                    </Translate>
                ),
            },
        ],
    },
}

export const CourseClassTimetableCreationModal = ({
                                                      course_id,
                                                      course_class_id,
                                                      owner_id,
                                                      owner_type,
                                                      onSubmit = NullAsDefault,
                                                  }) => {
    const t = useTranslate()
    const [resetKey, setResetKey] = useState();

    const initialValues = useMemo(
        () => ({
            owner: {_type: owner_type, id: owner_id},
            owner_id,
            owner_type,
            course_id,
            course_class_id,
            teacher: undefined,
            subject: undefined,
            from_date: undefined,
            to_date: undefined,
            from_time: undefined,
            to_time: undefined,
            is_holiday: 0,
        }),
        [owner_id, owner_type, course_id]
    )

    const validate = (values) => {
        let errors = {}

        const {from_date, to_date, from_time, to_time, is_holiday} = values ?? {}

        if (!from_date) {
            errors.from_date = t('required field')
        }
        if (!to_date) {
            errors.to_date = t('required field')
        }
        if (is_holiday === 0 && !from_time) {
            errors.from_time = t('required field')
        }
        if (is_holiday === 0 && !to_time) {
            errors.to_time = t('required field')
        }

        return errors
    }

    return (
        <Formik
            onSubmit={(values) => {
                const changes = shallowDiff(values, initialValues)
                const {subject, teacher, from_date, to_date, from_time, to_time, ...rest} = changes ?? {}

                onSubmit(
                    _.omitBy(
                        {
                            ...rest,
                            from_date: getDateString(from_date),
                            to_date: getDateString(to_date),
                            from_time: from_time ? dayjs(from_time).format("HH:mm") : null,
                            to_time: to_time ? dayjs(to_time).format("HH:mm") : null,
                            teacher_id: values?.teacher ? getId(teacher) : null,
                            subject_id: values?.subject ? getId(subject) : null,
                        },
                        _.isUndefined
                    )
                )
            }}
            onReset={() => {
                setResetKey(Date.now())
            }}
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={initialValues}>
            <ActionModalWrapper action={<FormActionBar submitText="add"/>}>
                <Pure input={[resetKey]}>
                    <FieldsFactory formSchema={[formSchema.phase]}/>
                    <FieldsFactory formSchema={[formSchema.from_to_date, formSchema.is_holiday]}/>

                    <FormikConsumer>
                        {({values, setFieldValue}) => {
                            const {is_holiday} = values

                            return renderIfElse(
                                is_holiday === 0,
                                <Pure>
                                    <div className="flex flex-col gap-3">
                                        <div className="flex flex-col gap-2 pt-3">
                                            <HeaderWithIconLine
                                                renderTitle={() => (
                                                    <div className="space-x-1">
                                                        <PiMapPinLineFill size={15} className="text-color-500 mr-1"/>
                                                        <span
                                                            className="font-bold text-base text-color-300 uppercase tracking-wider ">
                                                        {`${t('time')} / ${t('locations')}`}
                                                    </span>
                                                    </div>
                                                )}
                                            />
                                            <div className="flex flex-col gap-3">
                                                <FieldsFactory formSchema={[formSchema.from_to_time]}/>
                                                <FieldsFactory formSchema={[formSchema.days_of_week]}/>
                                                <FieldsFactory formSchema={[formSchema.location_address]}/>
                                            </div>
                                        </div>
                                        <div className="flex flex-col gap-2 pt-4">
                                            <HeaderWithIconLine
                                                renderTitle={() => (
                                                    <div className="space-x-1">
                                                        <FaUserTie size={15} className="text-color-500 mr-1"/>
                                                        <span
                                                            className="font-bold text-base text-color-300 uppercase tracking-wider ">
                                                        {`${t('teachers')} / ${t('subjects')}`}
                                                    </span>
                                                    </div>
                                                )}
                                            />
                                            <FieldsFactory
                                                formSchema={[
                                                    formSchema.subject,
                                                    formSchema.teacher,
                                                    formSchema.notes,
                                                ]}
                                            />
                                        </div>
                                    </div>
                                </Pure>,
                                <FieldsFactory
                                    formSchema={[
                                        formSchema.teacher,
                                        formSchema.notes,
                                    ]}
                                />
                            )
                        }}
                    </FormikConsumer>


                </Pure>
            </ActionModalWrapper>
        </Formik>
    )
}

export const CourseClassTimetableEditingModal = ({
                                                     item,
                                                     owner_id,
                                                     owner_type,
                                                     course_id,
                                                     course_class_id,
                                                     onSubmit = NullAsDefault,
                                                 }) => {
    const t = useTranslate()
    const [isToggle, toggle] = useToggle()
    const initialValues = useMemo(() => {
        const {from_date, to_date, ...rest} = item ?? {}
        return {
            ...rest,
            owner_id,
            course_id,
            owner_type,
            course_class_id,
            from_date: parseDayjs(from_date),
            to_date: parseDayjs(to_date),
        }
    }, [item, owner_id, owner_type, course_id])

    const validate = (values) => {
        let errors = {}

        const {from_date, to_date, from_time, to_time, is_holiday} = values ?? {}

        if (!from_date) {
            errors.from_date = t('required field')
        }
        if (!to_date) {
            errors.to_date = t('required field')
        }
        if (is_holiday === 0 && !from_time) {
            errors.from_time = t('required field')
        }
        if (is_holiday === 0 && !to_time) {
            errors.to_time = t('required field')
        }

        return errors
    }

    return (
        <Formik
            onSubmit={(values) => {
                const changes = shallowDiff(values, initialValues)
                const {subject, teacher, from_date, to_date, from_time, to_time, timetable_details, ...rest} =
                changes ?? {}
                onSubmit(
                    _.omitBy(
                        {
                            ...rest,
                            from_date: getDateString(from_date),
                            to_date: getDateString(to_date),
                            from_time: !!from_time ? dayjs(from_time).format("HH:mm") : undefined,
                            to_time: !!to_time ? dayjs(to_time).format("HH:mm") : undefined,
                            teacher_id: values?.teacher ? getId(teacher) : null,
                            subject_id: values?.subject ? getId(subject) : null,
                            timetable_details: JSON.stringify(timetable_details)
                        },
                        _.isUndefined
                    )
                )
            }}
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={initialValues}>
            <ActionModalWrapper action={<FormActionBar submitText="save"/>}>
                <div className="flex flex-col gap-3">
                    <HeaderWithIconLine
                        icon={<PiWarningCircleFill size={15} className="text-color-500"/>}
                        title="basic information"
                        className="text-base text-color-300"
                        extra={
                            <TooltipApp title={t('click to expand')} placement="bottomRight"
                                        classNames={{root: "text-xs italic"}}>
                                <Avatar
                                    size={22}
                                    className="flex flex-center bg-blue-100 hover:bg-blue-200 rounded-xs cursor-pointer"
                                    icon={isToggle ? <BsCaretDownFill size={12} className="text-blue-600"/> :
                                        <BsCaretRightFill size={12} className="text-blue-600"/>}
                                    onClick={() => toggle()}
                                />
                            </TooltipApp>
                        }
                    />
                    {isToggle && (
                        <Pure>
                            <FieldsFactory
                                formSchema={[
                                    formSchema.phase,
                                    formSchema.from_to_date,
                                    formSchema.subject,
                                    formSchema.teacher,
                                    formSchema.notes,
                                    formSchema.is_holiday,
                                ]}
                            />
                        </Pure>
                    )}
                </div>
                <div className="flex flex-col gap-2 mt-2">
                    <HeaderWithIconLine
                        icon={<PiMapPinLineFill size={15} className="text-color-500"/>}
                        title={`${t('time')} / ${t('locations')}`}
                        className="text-base text-color-300"
                    />
                    <FieldsFactory
                        formSchema={[
                            formSchema.from_to_time,
                            formSchema.days_of_week,
                            formSchema.location_address,
                        ]}
                    />
                </div>
                <div className="flex flex-col gap-2 mt-2">
                    <HeaderWithIconLine
                        icon={<PiListNumbersBold size={15} className="text-color-500"/>}
                        title={`${t('detail')} ${t('timetables')}`}
                        className="text-base text-color-300"
                    />
                    <FieldsFactory formSchema={[formSchema.timetable_details]}/>
                </div>
            </ActionModalWrapper>
        </Formik>
    )
}

export const CourseClassTimetableCopyModal = ({
                                                  item,
                                                  owner_id,
                                                  owner_type,
                                                  course_id,
                                                  course_class_id,
                                                  onSubmit = NullAsDefault,
                                              }) => {
    const t = useTranslate()
    const [isToggle, toggle] = useToggle();

    const initialValues = useMemo(() => {
        const {id, from_date, to_date, ...rest} = item ?? {}
        return {
            ...rest,
            subject_id: rest?.subject?.id,
            owner_id,
            course_id,
            owner_type,
            course_class_id,
            from_date: parseDayjs(from_date),
            to_date: parseDayjs(to_date)
        }
    }, [item, owner_id, owner_type, course_id])

    const validate = (values) => {
        let errors = {}

        const {from_date, to_date, from_time, to_time} = values ?? {}

        if (!from_date) {
            errors.from_date = t('required field')
        }
        if (!to_date) {
            errors.to_date = t('required field')
        }
        if (!from_time) {
            errors.from_time = t('required field')
        }
        if (!to_time) {
            errors.to_time = t('required field')
        }

        return errors
    }

    return (
        <Formik
            onSubmit={(values) => {
                const {subject, teacher, from_date, to_date, from_time, to_time, timetable_details, ...rest} = values ?? {}
                onSubmit(
                    _.omitBy(
                        {
                            ...rest,
                            from_date: getDateString(from_date),
                            to_date: getDateString(to_date),
                            from_time: !!from_time ? dayjs(from_time, "HH:mm:ss").format("HH:mm") : undefined,
                            to_time: !!to_time ? dayjs(to_time, "HH:mm:ss").format("HH:mm") : undefined,
                            teacher_id: values?.teacher ? getId(teacher) : null,
                            subject_id: values?.subject ? getId(subject) : null,
                            timetable_details: JSON.stringify(timetable_details)
                        },
                        _.isUndefined
                    )
                )
            }}
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={initialValues}>
            <ActionModalWrapper action={<FormActionBar submitText="create new"/>}>
                <div className="flex flex-col gap-3">
                    <HeaderWithIconLine
                        icon={<PiWarningCircleFill size={15} className="text-color-500"/>}
                        title="basic information"
                        className="text-base text-color-300"
                        extra={
                            <TooltipApp title={t('click to expand')} placement="bottomRight"
                                        classNames={{root: "text-xs italic"}}>
                                <Avatar
                                    size={22}
                                    className="flex flex-center bg-blue-100 hover:bg-blue-200 rounded-xs cursor-pointer"
                                    icon={isToggle ? <BsCaretDownFill size={12} className="text-blue-600"/> :
                                        <BsCaretRightFill size={12} className="text-blue-600"/>}
                                    onClick={() => toggle()}
                                />
                            </TooltipApp>
                        }
                    />
                    {isToggle && (
                        <Pure>
                            <FieldsFactory
                                formSchema={[
                                    formSchema.phase,
                                    formSchema.from_to_date,
                                    formSchema.subject,
                                    formSchema.teacher,
                                    formSchema.is_holiday,
                                    formSchema.notes

                                ]}
                            />
                        </Pure>
                    )}
                </div>
                <div className="flex flex-col gap-2 mt-2">
                    <HeaderWithIconLine
                        icon={<PiMapPinLineFill size={15} className="text-color-500"/>}
                        title={`${t('time')} / ${t('locations')}`}
                        className="text-base text-color-300"
                    />
                    <FieldsFactory
                        formSchema={[
                            formSchema.from_to_time,
                            formSchema.days_of_week,
                            formSchema.location_address,
                        ]}
                    />
                </div>
            </ActionModalWrapper>
        </Formik>
    )
}

export const CourseClassTimetables = ({
                                          item: courseClass,
                                          header = null,
                                          renderFooter = renderSelf,
                                      }) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)
    const [filterSubject, setFilterSubject] = useState(false)
    const [refreshKey, setRefreshKey] = useState();
    const {
        modal,
        renderContextMenu,
        handleAction = NullAsDefault,
    } = useCourseClassTimetable({item: courseClass, refreshKey, setRefreshKey})
    const {class_subjects = [], coordinators = [], number_of_students, description, course_class_idcode, course, title} = courseClass ?? {}

    return (
        <ActionModalWrapper className="flex-1">
            {header}
            <div className="mt-6 flex flex-col gap-1">
                <div className="font-bold text-base text-gray-700 tracking-wide uppercase">
                    {t('class information')}
                </div>
                <div className="ml-2 flex flex-col gap-1">
                    <ItemInformation
                        showIcon={true}
                        label="course class idcode"
                        value={course_class_idcode}
                        className="text-xs italic"
                    />
                    <ItemInformation
                        showIcon={true}
                        label="belong to the course"
                        value={getTitle(course)}
                        className="text-xs italic"
                    />
                    {renderIf(
                        coordinators.length > 0,
                        <span className="space-x-1 text-xs italic">
                <GoDotFill size={10} className="text-color-400"/>
                <span className="text-color-500">{`${t('class coordinator')} : `}</span>
                            {coordinators.map((e, i) => (
                                <span key={i} className="font-semibold text-color-100">
                      {e?.teacher_name} {i < coordinators.length - 1 && ', '}
                    </span>
                            ))}
              </span>
                    )}
                    <ItemInformation
                        showIcon={true}
                        label="number of student"
                        value={`${number_of_students || 0} ${t('students')}`}
                        className="text-xs italic"
                    />
                    {renderIf(
                        class_subjects.length > 0,
                        <span className="space-x-1 text-xs italic">
                <GoDotFill size={10} className="text-color-400"/>
                <span className="text-color-500">{`${t('subjects')} : `}</span>
                            {class_subjects.map((e, i) => (
                                <span key={i} className="font-semibold text-color-100">
                      {e?.subject?.title} {i < class_subjects.length - 1 && ', '}
                    </span>
                            ))}
              </span>
                    )}
                </div>
            </div>
            <div className="mt-6 flex flex-col gap-1">
                <div className="font-bold text-base text-gray-700 tracking-wide uppercase">
                    {t('timetable for the class')}
                </div>
                <div className="ml-2 flex flex-col gap-1">
                    {class_subjects.length > 0 && (
                        <div className="mt-1 flex items-baseline flex-wrap gap-1">
                            <span className="text-xs text-color-400 italic whitespace-no-wrap leading-snug 111-111">
                                {`${t('subjects')} : `}
                            </span>
                            <div className="flex flex-wrap gap-y-1 gap-x-2">
                                {class_subjects.map((e, i) => (
                                    <span
                                        key={i}
                                        style={{padding: '0px 8px', height: 24, borderRadius: 4}}
                                        onClick={() => {
                                            if (filterSubject === e) {
                                                setFilterSubject(null)
                                            } else {
                                                setFilterSubject(e)
                                            }
                                        }}
                                        className={classNames(
                                            "flex flex-center cursor-pointer rounded-md font-semibold text-xs",
                                            filterSubject === e ?
                                                "bg-blue-100 hover:bg-blue-200 text-blue-600" :
                                                "background-100 hover:bg-blue-50 text-color-300 hover:text-blue-500"
                                        )}>
                                    {e?.subject?.title}
                                </span>
                                ))}
                            </div>
                        </div>
                    )}
                    <div className="mt-3 flex flex-col gap-4">
                        {!!courseClass?.id && (
                            <EntityList
                                refreshKey={refreshKey}
                                key={filterSubject?.subject?.id}
                                RenderEntity={React.Fragment}
                                values={{subject_id: filterSubject?.subject?.id}}
                                query={bindQueryParams([{id: getId(courseClass)}])}
                                apiInfo={course_class_getCourseClassMilestones_Api}
                                renderItem={renderCourseClassTeacherAssignment({renderContextMenu})}
                                renderWrap={(child) => (
                                    <div className="flex flex-col gap-4">{child}</div>
                                )}
                                renderEmpty={() => (
                                    <div
                                        className="p-6 flex flex-col items-center gap-3 border border-color-50 rounded-xl shadow-md">
                                        <BsInboxesFill size={40} style={{color: '#dedede'}}/>
                                        <span className="text-center text-sm text-color-300 tracking-wider italic">
                                        {t('no data is available now')}
                                    </span>
                                    </div>
                                )}
                            />
                        )}
                    </div>
                </div>
            </div>
            {renderFooter(null)}
            {modal}
        </ActionModalWrapper>
    )
}
